<div class="p-fieldset field">
  <label for="{{label}}" class="font-medium">{{ label }}</label>

  <!-- Required Badge (Shown if field is required but empty) -->
  <div *ngIf="control.errors?.['required']" class="required">
    <span class="bg-slate-100">Required</span>
  </div>

  <div *ngIf="control.touched && control.errors?.['required']" class="required text-orange-900">
    <span class="bg-orange-100"><i class="pi pi-exclamation-triangle"></i> Required</span>
  </div>
  <!-- Input -->
  <div class="flex align-items-center relative" [ngClass]="isShowHide? 'justify-content-end' : ''">
    <input
      pInputText
      [formControl]="control"
      [placeholder]="placeholder"
      [type]="type"
      [attr.maxlength]="maxLength"
      class="flex w-full"
      [ngClass]="cardBrandImage ? 'pl-5' : showError && highlightOnError ? 'ng-dirty ng-invalid' : ''"
      [attr.data-auto-id]="dataAutoId"
      [attr.aria-label]="label ? label : ''"
    />
    <span *ngIf="isShowHide" data-auto-id="toggle-button" class="absolute mr-2 cursor-pointer justify-content-end text-slate-500" (click)="toggleVisibility()">
      <i class="pi" [ngClass]="show ? 'pi-eye-slash' : 'pi-eye'"></i>
    </span>
    <ng-container *ngIf="cardBrandImage">
      <i *ngIf="cardBrandImage.includes('credit')" class="pi pi-credit-card text-slate-500 absolute ml-2 h-1rem"></i>
      <img *ngIf="!cardBrandImage.includes('credit')" [src]="cardBrandImage" alt="Card Icon" class="absolute ml-2 h-1rem" data-auto-id="card-type-image" />
    </ng-container>
  </div>
  <ng-content select="[extra-content]"></ng-content>
  <!-- Error Messages -->
  <div *ngIf="showError" class="mt-1 text-rose-600">
    <small *ngIf="control.errors?.['required']">
      {{ label }} is required.
    </small>
    <small *ngIf="control.errors?.['pattern']">
      {{ label }} is not valid.
    </small>
    <small *ngIf="control.errors?.['minlength']">
      {{ label }} is not valid.
    </small>
    <ng-content select="[extra-error]"></ng-content>
  </div>
  <div *ngIf="!showError && isEmailInput" class="mt-1 text-slate-600">
    <small>
      Changing this email won't affect your login credentials.
    </small>
  </div>

</div>
